import React from 'react';
import Paper from '@material-ui/core/Paper';
import { TextField, Button, Box, Typography } from '@material-ui/core';
import useStyles from './styles';

const OtpBox = ({ otp, onChange, onSubmit }) => {
  const classes = useStyles();

  return (
    <Paper className={classes.card} elevation={3}>
      <div className={classes.inputsContainer}>
        <Typography component="div">
          <Box letterSpacing={6} m={1}>
            SportVot Admin
          </Box>
        </Typography>
        <TextField
          className={classes.inputBox}
          type="number"
          id="otp"
          label="OTP"
          variant="outlined"
          value={otp}
          onChange={e => onChange(e.target.value)}
        />

        <Button
          className={classes.loginButton}
          variant="outlined"
          color="primary"
          onClick={() => onSubmit()}
        >
          SUBMIT
        </Button>
      </div>
    </Paper>
  );
};

export default OtpBox;
